(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/assets/javascripts/models/odds.js') >= 0) return;  svs.modules.push('/modules/matchen/assets/javascripts/models/odds.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.matchen = svs.matchen || {};
  svs.matchen.models = svs.matchen.models || {};

  svs.matchen.models.Odds = Backbone.Model.extend({
    defaults: function() {
      return {
        drawNumber: '',
        sortorder: 'Result',
        list1Odds: new Backbone.Collection(),
        listXOdds: new Backbone.Collection(),
        list2Odds: new Backbone.Collection()
      };
    },

    url: function() {
      var drawNumber = this.get('drawNumber');
      var sortOrder = this.get('sortorder');

      if (!drawNumber || !sortOrder) {
        this.logger.warn(
          'Invalid drawNumber or sortOrder',
          drawNumber,
          sortOrder
        );
      }

      return (
        svs.core.jupiter.url() +
        '/draw/1/matchen/draws/' +
        drawNumber +
        '/oddslist?sortorder=' +
        sortOrder
      );
    },

    initialize: function() {
      this.logger = new svs.core.log.Logger('svs.matchen.models.Odds');
    },

    parse: function(data) {
      if (!data || data.error || !data.oddslist) {
        this.logger.warn('Invalid data or error.', data);
        return {};
      }

      var oddsList = data.oddslist;

      this.parseOddsLists(oddsList);

      _.extend(oddsList, { sortorder: data.sortorder });

      return _.omit(oddsList, 'list1Odds', 'listXOdds', 'list2Odds');
    },

    parseOddsLists: function(oddslist) {
      var lists = ['list1Odds', 'listXOdds', 'list2Odds'];

      _.each(
        lists,
        function(list) {
          this.get(list).set(oddslist[list]);
        },
        this
      );
    },

    getHomeOdds: function() {
      return this.get('list1Odds');
    },

    getDrawOdds: function() {
      return this.get('listXOdds');
    },

    getAwayOdds: function() {
      return this.get('list2Odds');
    },

    setSortOrder: function(order, options) {
      options = _.extend({ silent: true }, options);

      this.set('sortorder', order, options);
    },

    getOddsForResult: function(result) {
      var list;
      var odds;
      var oddsItem;

      if (result instanceof svs.matchen.models.Result) {
        if (result.isHomeWin()) {
          list = this.getHomeOdds();
        } else if (result.isDraw()) {
          list = this.getDrawOdds();
        } else if (result.isAwayWin()) {
          list = this.getAwayOdds();
        }

        oddsItem = _.findWhere(list, {
          result: result.getFormattedResult({
            withMarkup: false,
            withSpace: false
          })
        });

        if (oddsItem) {
          odds = oddsItem.odds;
        }
      }

      return odds;
    },

    getSortOrder: function(lowerCase) {
      var sortOrder = this.get('sortorder');

      return lowerCase ? sortOrder && sortOrder.toLowerCase() : sortOrder;
    },

    getOddsTime: function() {
      return this.get('oddsTime');
    }
  });
})(Backbone, _, svs);


 })(window);